import { ReactElement } from "react";

import { Box } from "@twilio-paste/core/box";
import { NewIcon } from "@twilio-paste/icons/esm/NewIcon";
import { ProcessDisabledIcon } from "@twilio-paste/icons/esm/ProcessDisabledIcon";
import { SuccessIcon } from "@twilio-paste/icons/esm/SuccessIcon";
import { ProcessDraftIcon } from "@twilio-paste/icons/esm/ProcessDraftIcon";
import { ProcessInProgressIcon } from "@twilio-paste/icons/esm/ProcessInProgressIcon";
import { WarningIcon } from "@twilio-paste/icons/esm/WarningIcon";

import { types } from "./definitions";
import styles from "./StatusBadge.module.css";
import { TicketStatus } from "@twiliointernal/e2-commons-shared-definitions";

const statusToPasteBadgeIcon: Record<TicketStatus, ReactElement<any, any>> = {
  [TicketStatus.new]: <NewIcon color="colorTextIconNew" decorative />,
  [TicketStatus.open]: (
    <ProcessDraftIcon color="colorTextIconNeutral" decorative />
  ),
  [TicketStatus.pending]: (
    <ProcessInProgressIcon color="colorTextIconNeutral" decorative />
  ),
  [TicketStatus.hold]: <WarningIcon color="colorTextIconBusy" decorative />,
  [TicketStatus.solved]: (
    <SuccessIcon color="colorTextIconSuccess" decorative />
  ),
  [TicketStatus.closed]: (
    <ProcessDisabledIcon color="colorTextIconOffline" decorative />
  ),
};

const StatusBadge = ({ status }: types.StatusBadgeProps): ReactElement => (
  <Box as="div" className={styles.statusBadgeContainer}>
    {statusToPasteBadgeIcon[status]}
    {status}
  </Box>
);

export default StatusBadge;
